import { Navigate } from "react-router-dom";

// Silim girişi Veri Girişi › "ATM Silim Hizmeti Veri Girişi" kutusunda (taşeron dahil); eski bağlantılar (ör. hatırlatma e-postası) oraya yönlenir
export default function AtmWipes() {
  return <Navigate to="/veri-girisi?bolum=hizmet&grup=atm" replace />;
}
